// extracted by mini-css-extract-plugin
export default {"indicatorContainer":"kI15vO","flexbox":"tUiwcC","privateIndicator":"Vsfdzq","toTheRight":"a9OJbf","toTheBottom":"CDwrIO"};